import { Row, Col, Form, Input, Space,Select } from 'antd';
import classes from '../Pages.module.css';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import NormDataField from './NormDataField';

const { Option } = Select;

const LeaveNormDetails = (props) => {

    const handleValueChanges = (changedValues, allValues) => {

        props.setData(data => {

            return ({
                ...data,
                details: {
                    ...data.details,
                    rows: allValues.leaveNorms
                }
            })
        })
    }

    return (
        props.editMode
            ?
            <Form layout="vertical" name="filter_form" onValuesChange={handleValueChanges} autoComplete="off">
                <Form.List name="leaveNorms" initialValue={props.data.length > 0 ? props.data : [{}]}>
                    {(fields, { add, remove }) => {

                        return (
                            <>
                                {fields.map(({ key, name, fieldKey, ...restField }) => (
                                    <Space key={key} className={classes['Space']} align="center">
                                        <Row gutter={16}>
                                            <p></p>
                                            <Col lg={6} md={12}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'leave_type']}
                                                    fieldKey={[fieldKey, 'leave_type']}
                                                    label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}>Leave Type</div>}
                                                    rules={[{ required: true, message: 'Missing Name' }]}
                                                >
                                                    <Select
                                                        bordered={true}
                                                        style={{ width: "100%", textAlign: "left", float: "left", backgroundColor: "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                                        placeholder="Select"
                                                        optionFilterProp="children"
                                                    >
                                                        {
                                                            props.ad.LEAVE_TYPE.rows.map((option) => {
                                                                return (
                                                                    <Option style={{ textTransform: "capitalize", color: "#1777C4" }} key={option[props.ad.LEAVE_TYPE.fields[0].name]} value={option[props.ad.LEAVE_TYPE.fields[0].name]}>{option[props.ad.LEAVE_TYPE.fields[1].name]}</Option>
                                                                );
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6} md={12}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'leaves_no']}
                                                    fieldKey={[fieldKey, 'leaves_no']}
                                                    label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}>NO. OF Leaves</div>}
                                                    rules={[{ required: true, message: 'Missing Name' }]}
                                                >
                                                    <Input
                                                        style={{ width: "100%", float: "left", backgroundColor: "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                                        bordered={true}
                                                        placeholder="Enter Data"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6} md={12}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'leave_pay']}
                                                    fieldKey={[fieldKey, 'leave_pay']}
                                                    label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}>Leave With Pay</div>}
                                                    rules={[{ required: true, message: 'Missing Name' }]}
                                                >
                                                    <Select
                                                        bordered={true}
                                                        style={{ width: "100%", textAlign: "left", float: "left", backgroundColor: "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                                        placeholder="Select"
                                                        optionFilterProp="children"
                                                    >
                                                        {
                                                            props.ad.YESNO.rows.map((option) => {
                                                                return (
                                                                    <Option style={{ textTransform: "capitalize", color: "#1777C4" }} key={option[props.ad.YESNO.fields[0].name]} value={option[props.ad.YESNO.fields[0].name]}>{option[props.ad.YESNO.fields[1].name]}</Option>
                                                                );
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6} md={12}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'month_increment']}
                                                    fieldKey={[fieldKey, 'month_increment']}
                                                    label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}>Monthly Increment</div>}
                                                    rules={[{ required: true, message: 'Missing Name' }]}
                                                >
                                                    <Select
                                                        bordered={true}
                                                        style={{ width: "100%", textAlign: "left", float: "left", backgroundColor: "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                                        placeholder="Select"
                                                        optionFilterProp="children"
                                                    >
                                                        {
                                                            props.ad.YESNO.rows.map((option) => {
                                                                return (
                                                                    <Option style={{ textTransform: "capitalize", color: "#1777C4" }} key={option[props.ad.YESNO.fields[0].name]} value={option[props.ad.YESNO.fields[0].name]}>{option[props.ad.YESNO.fields[1].name]}</Option>
                                                                );
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col lg={21} md={0}>

                                            </Col>
                                            <Col lg={1} md={24}>
                                                {name !== 0 && ( // Hide delete for first row
                                                    <MinusCircleOutlined
                                                        className={classes['Remove']}
                                                        onClick={() => remove(name)}
                                                    />
                                                )}
                                            </Col>
                                            <Col lg={1} md={24}>
                                                <PlusCircleOutlined className={classes['Add']} onClick={() => { add() }} />
                                            </Col>
                                            <Col lg={1} md={24}>

                                            </Col>
                                            <Col lg={24} md={24}>
                                                <hr></hr>
                                            </Col>
                                        </Row>
                                    </Space>
                                ))}
                                {/* <Form.Item>
                                    <Button type="dashed" className={classes['DashedButton']} onClick={() => { add() }}>
                                        Add Leave Norm
                                    </Button>
                                </Form.Item> */}
                            </>
                        )
                    }}
                </Form.List>
            </Form>
            :
            <>
                {
                    props.data.map((element, index) => {
                        return (
                            <div key={index}>
                                <strong>LEAVE NORM {index + 1}</strong>
                                <p></p>
                                <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
                                    <NormDataField editMode={false} lg={12} md={24} options={props.ad.LEAVE_TYPE} type="Select" name="LEAVE TYPE" value={element.LEAVE_TYPE ? element.LEAVE_TYPE : null} />
                                    <NormDataField editMode={false} lg={12} md={24} name="NO. OF LEAVES" value={element.LEAVES_NO ? element.LEAVES_NO : null} />
                                    <NormDataField editMode={false} lg={12} md={24} options={props.ad.YESNO} type="Select" name="LEAVE WITH PAY" value={element.LEAVE_PAY ? element.LEAVE_PAY : null} />
                                    <NormDataField editMode={false} lg={12} md={24} options={props.ad.YESNO} type="Select" name="MONTHLY INCREMENT" value={element.MONTH_INCREMENT ? element.MONTH_INCREMENT : null} />
                                </Row>
                                <p></p>
                                <hr></hr>
                            </div>
                        );
                    })
                }
            </>
    )
}

export default (LeaveNormDetails)